import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import AccountService from '../../api/service/member/AccountService'; // AccountService 가져오기
import { LoginPageUrl } from '../../url/poenUrl';

const Container = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.whiteColor};
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 20px 10px 10px 10px;
  max-width: 1024px;
  margin: 0 auto;
  border-radius: 10px;
  @media (max-width: 768px) {
    gap: 15px;
    padding-top: 0px;
  }
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const Row = styled.div`
  display: flex;
  gap: 15px;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  width: 200px;
  text-align: left;
`;

const Text = styled.div`
  width: 100%;
  padding: 10px;
  font-size: 14px;
  line-height: 20px;
  word-break: keep-all;
  color: #666;
  background-color: #f9f9f9;
  border-radius: 4px;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;

  border: 1px solid ${({ theme }) => theme.colors.inputLine};
  background-color: ${({ theme }) => theme.colors.inputBG};
  border-radius: 6px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.mainColor};
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  resize: none;
  height: 300px;

  border: 1px solid ${({ theme }) => theme.colors.inputLine};
  background-color: ${({ theme }) => theme.colors.inputBG};
  border-radius: 6px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.mainColor};
  }
`;

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
`;

const UpdateButton = styled.button`
  flex: 1;
  padding: 10px 16px;
  background-color: ${({ theme }) => theme.colors.subColor};
  color: white;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.subHoverColor};
  }
`;

const MyPageTab3 = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    password: '',
    reason: '',
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSecession = async () => {
    if (!formData.password.trim()) {
      alert('비밀번호를 입력해주세요.');
      return;
    }

    // 사용자 확인
    const confirmSecession = window.confirm('정말로 탈퇴하시겠습니까?');
    if (!confirmSecession) {
      return; // 사용자가 취소한 경우 함수 종료
    }

    try {
      // 회원 탈퇴 API 호출
      await AccountService.deleteMemberAccount(formData);
      alert('회원 탈퇴가 완료되었습니다.');

      navigate(LoginPageUrl); // 탈퇴 후 메인 페이지로 이동
    } catch (error) {
      console.error('회원 탈퇴 실패:', error);
      alert(error);
    }
  };

  return (
    <Container>
      <Form>
        <Section>
          <Row>
            <Label>회원 탈퇴 안내</Label>
            <Text>
              회원 탈퇴를 진행하시면 모든 정보가 삭제됩니다. 탈퇴 후에는 복구할
              수 없습니다.
            </Text>
          </Row>
          <Row>
            <Label>비밀번호 입력</Label>
            <Input
              type="password"
              placeholder="비밀번호를 입력해주세요"
              name="password"
              value={formData.password}
              onChange={handleChange}
            />
          </Row>
          <Row>
            <Label>불편한 점이 있으셨나요?</Label>
            <TextArea
              placeholder="불편한 점이나 건의 사항을 남겨주세요."
              name="reason"
              value={formData.reason}
              onChange={handleChange}
            />
          </Row>
        </Section>

        <ButtonContainer>
          <UpdateButton type="button" onClick={handleSecession}>
            탈퇴하기
          </UpdateButton>
        </ButtonContainer>
      </Form>
    </Container>
  );
};

export default MyPageTab3;
